// extracted by mini-css-extract-plugin
export default {"sideBar":"Sidebar_sideBar__cga8v","sideBar__iconBox":"Sidebar_sideBar__iconBox__SPMef","sideBar__icon1":"Sidebar_sideBar__icon1__wH-Uf"};